
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M54 10c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 .35.03.7.09 1.03a5.99 5.99 0 016.62 1.26l-1.42 1.42a3.987 3.987 0 00-4.62-.74A6.962 6.962 0 0047 17c3.87 0 7-3.13 7-7zm-35.072-.268l1.732-1-2-3.464-1.732 1 .5.866-1.805 1.042A5.994 5.994 0 0012 6.09V4h1V2H9v2h1v2.09a5.994 5.994 0 00-3.623 2.086L4.572 7.134l.5-.866-1.732-1-2 3.464 1.732 1 .5-.866 1.81 1.045C5.139 10.563 5 11.264 5 12s.139 1.437.381 2.089l-1.81 1.045-.5-.866-1.732 1 2 3.464 1.732-1-.5-.866 1.805-1.042A6 6 0 0010 17.91V20H9v2h4v-2h-1v-2.09a5.994 5.994 0 003.623-2.086l1.805 1.042-.5.866 1.732 1 2-3.464-1.732-1-.5.866-1.81-1.045c.243-.652.382-1.353.382-2.089s-.139-1.437-.381-2.089l1.81-1.045.499.866zM11 16a4 4 0 110-8 4 4 0 010 8zM30.293 15.293l1.414 1.414L36.414 12l-4.707-4.707-1.414 1.414L32.586 11H25v2h7.586zM21 11h2v2h-2z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M56 17H39.479a6 6 0 00-5.975 5.457L33 28l-8 6 4 5 10-7v-8h2v8h-2v6l-4 24h8l4-24v24h8V24h2v14h5V23a6 6 0 00-6-6zm-8 16h-2v-2h2v2zm0-4h-2v-8h2v8z"}})])
          )
        }
      }
    